/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the LoginEmailPasswordDto interface.
 */
export function instanceOfLoginEmailPasswordDto(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('password' in value) || value['password'] === undefined)
        return false;
    return true;
}
export function LoginEmailPasswordDtoFromJSON(json) {
    return LoginEmailPasswordDtoFromJSONTyped(json, false);
}
export function LoginEmailPasswordDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
        'password': json['password'],
    };
}
export function LoginEmailPasswordDtoToJSON(json) {
    return LoginEmailPasswordDtoToJSONTyped(json, false);
}
export function LoginEmailPasswordDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
        'password': value['password'],
    };
}
